// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * This module provides functionality to upload an organization's logo to the remote API.
 */
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a file to the remote API to be used as the logo for the current
 * user's organization.
 *
 * @param file - The file to upload as the organization's logo.
 * @returns A promise that resolves when the upload is complete.
 * @throws Will throw if the file upload fails or if the file is invalid.
 */
export async function uploadOrganizationLogo(file: File) {
  return uploadFile(file, { context: 'LOGO', isPublic: true });
}
